import axios from 'axios';

const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  responseType: 'json',
  withCredentials: true,
});

export default Api;
